var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 62,
    viewBox: "0 0 48 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1484 62C28.0589 62 31.3718 59.4449 32.5046 55.9152C33.1044 56.0741 33.7344 56.1587 34.3842 56.1587C38.422 56.1587 41.6953 52.8897 41.6953 48.8571C41.6953 48.2085 41.6106 47.5797 41.4517 46.981C44.9872 45.8503 47.5467 42.5411 47.5467 38.6349C47.5467 36.0029 46.3846 33.6419 44.545 32.0358C45.7398 30.2682 46.4375 28.1378 46.4375 25.8447C46.4375 19.7263 41.4711 14.7664 35.3448 14.7664C33.4064 14.7664 31.5841 15.2629 29.9986 16.1355V3.58732C29.9986 1.9743 28.6893 0.666687 27.0741 0.666687H21.2252C19.6101 0.666687 18.3008 1.9743 18.3008 3.58732V16.1369C16.7146 15.2634 14.8915 14.7664 12.9521 14.7664C6.82577 14.7664 1.85938 19.7263 1.85938 25.8447C1.85938 28.1387 2.55757 30.2699 3.75331 32.0378C1.91498 33.6439 0.753906 36.004 0.753906 38.6349C0.753906 42.5399 3.31176 45.8482 6.84546 46.9799C6.68635 47.5789 6.60156 48.2081 6.60156 48.8571C6.60156 52.8897 9.87487 56.1587 13.9127 56.1587C14.5624 56.1587 15.1924 56.0741 15.7921 55.9152C16.9249 59.4449 20.2379 62 24.1484 62Z",
    fill: "#329D9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderTree);
export default __webpack_public_path__ + "static/media/loader-tree.4170bc5a0ff7c64ef6d8747aa396aa9c.svg";
export { ForwardRef as ReactComponent };